import axios from "axios";
import { $notify } from "@/toaster/ToasterPlugin";
const endpoint = "period";
export default {
  async fetchPeriods({ commit, state }) {
    let response;
    try {
      response = await axios.get(state.next_periods_url);
      if (state.shouldAppend) {
        commit("SET_PERIODS", [...state.periods, ...response.data.data]);
      } else {
        commit("SET_PERIODS", response.data.data);
      }
      commit("SET_NEXT_PERIODS_URL", response.data.links.next);
      commit("SET_SHOULD_APPEND", true);
      commit("SET_SUCCESS", true);
    } catch (e) {
      commit("SET_SUCCESS", false);
      console.error(e);
    }
  },

  async fetchPeriod(context, id) {
    return (await axios.get(`period/${id}`)).data.data;
  },

  async startPeriod({ commit }, id) {
    try {
      await axios.post(`owner/${endpoint}/start/${id}`);
      commit("SET_SUCCESS", true);
    } catch (e) {
      commit("SET_SUCCESS", false);
      $notify.apiError(e);
    }
  },

  async finishPeriod({ commit }, id) {
    try {
      await axios.post(`owner/${endpoint}/finish/${id}`);
      commit("SET_SUCCESS", true);
    } catch (e) {
      commit("SET_SUCCESS", false);
      $notify.apiError(e);
    }
  },

  updatePeriods({ commit, state }, period) {
    const otherPeriods = state.periods.filter(({ id }) => +id !== period.id);
    commit("SET_PERIODS", [period, ...otherPeriods]);
  },

  async destroyPeriod({ commit, state }, id) {
    try {
      await axios.post(`owner/${endpoint}/destroy/${id}`);
      commit("SET_SUCCESS", true);
      commit(
        "SET_PERIODS",
        state.periods.filter((period) => {
          return period.id !== +id;
        })
      );
    } catch (e) {
      console.error(e);
      commit("SET_SUCCESS", false);
      $notify.apiError(e);
    }
  },

  searchPeriod({ commit }, { keywords, station }) {
    commit(
      "SET_NEXT_PERIODS_URL",
      endpoint + "?keywords=" + keywords + "&station_id=" + (station?.id ?? "")
    );
    commit("SET_PERIODS", []);
    commit("SET_SHOULD_APPEND", false);
    commit("SET_SEARCH_STATION", station);
    commit("SET_SEARCH_KEYWORD", keywords);
  },
};
